export class HomeArticle {
    public title: string | undefined = '';
    public content: string | undefined = '';

    constructor(title: string, content: string) {
        this.title = title;
        this.content = content;
    }
}
